var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.642509 0.634882C1.0539 0.228374 1.61187 0 2.19366 0H7.80106C7.95794 0 8.10841 0.061584 8.21934 0.171204L13.8267 5.71203C13.9377 5.82165 14 5.97033 14 6.12536V14.8324C14 15.4073 13.7689 15.9586 13.3575 16.3651C12.9461 16.7716 12.3881 17 11.8063 17H2.19366C1.61187 17 1.0539 16.7716 0.642509 16.3651C0.231117 15.9586 0 15.4073 0 14.8324V2.16762C0 1.59273 0.231117 1.04139 0.642509 0.634882ZM2.19366 1.16905C1.92564 1.16905 1.6686 1.27426 1.47909 1.46153C1.28957 1.6488 1.1831 1.90278 1.1831 2.16762V14.8324C1.1831 15.0972 1.28957 15.3512 1.47909 15.5385C1.6686 15.7257 1.92564 15.8309 2.19366 15.8309H11.8063C12.0744 15.8309 12.3314 15.7257 12.5209 15.5385C12.7104 15.3512 12.8169 15.0972 12.8169 14.8324V6.36748L7.55603 1.16905H2.19366Z",
    fill: "#330072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80249 0C8.12919 0 8.39404 0.261702 8.39404 0.584527V5.54083H13.4099C13.7366 5.54083 14.0014 5.80253 14.0014 6.12536C14.0014 6.44818 13.7366 6.70989 13.4099 6.70989H7.80249C7.47578 6.70989 7.21094 6.44818 7.21094 6.12536V0.584527C7.21094 0.261702 7.47578 0 7.80249 0Z",
    fill: "#330072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e17a0785a001ad53613775afe7844d63.svg";
export { ForwardRef as ReactComponent };